import React, { Component } from 'react'
import { submitVote as submitVoteContract } from '../../../../contract/WagersController'
import { submitVote as submitVoteApi } from '../../../../api-calls/wagers'
import { Card, Popconfirm, Icon, message } from 'antd'
import { observer } from "mobx-react"
import Modal from 'react-modal'
import UserStore from '../../../../stores/UserStore';
@observer(["AuthStore", "UserStore", "TeamStore"])
export default class SubmitVote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            voteModalIsOpen: false,
            makerChoice: 0,
            oneBackground: "#041827",
            twoBackground: "#041827",
            chosenTeam: -1,

            teamOneLogo: "",
            teamTwoLogo: "",
            teamOneName: "",
            teamTwoName: "",
            chooseButton:  <button className="custom-btn-primary" onClick={() => this.setState({voteModalIsOpen: true})}>Choose</button>

        };
       
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitVote = this.submitVote.bind(this);
        this.teamOneClicked = this.teamOneClicked.bind(this);
        this.teamTwoClicked = this.teamTwoClicked.bind(this);
    }
    async componentDidMount() {
        const { TeamStore } = this.props;
        let team_one = this.props.event.teams[0];
        let team_two = this.props.event.teams[1];
        let self = this;
        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (team_one == team._id) {
                    self.setState({

                        teamOneLogo: team.logoUrl,
                        teamOneName: team.name
                    });
                }
                if (team_two == team._id) {
                    self.setState({

                        teamTwoLogo: team.logoUrl,
                        teamTwoName: team.name
                    });
                }
            });
            console.log("teams: " + JSON.stringify(TeamStore));
        }
            , 30

        );

    }

    submitVote() {
        const { AuthStore, UserStore } = this.props;
        let bytes32Id = this.props.bet.bytes32Id;
        let wagerId = this.props.bet._id;
        let userId = UserStore.user._id;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let winnerVote;
        let self = this;

        console.log("Submitting vote for bet " + this.props.bet.bytes32Id);
        if (this.state.chosenTeam == -1) { message.info("You must select a team!"); } else {
            self.closeModal();
            self.setState({chooseButton: <Icon style={{ fontSize: '16px', color: '#08c' }} theme="outlined" type="loading"/>});

            submitVoteContract(bytes32Id, self.state.chosenTeam).then(
                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! Vote not submit.");
                        self.setState({chooseButton: <button className="custom-btn-primary" onClick={() => this.setState({voteModalIsOpen: true})}>Choose</button>});
                    } else {
                        return submitVoteApi(
                            authToken,
                            wagerId,
                            bytes32Id
                        ).then(function () {
                            self.setState({chooseButton: <Icon style={{ fontSize: '16px', color: '#27f727' }} theme="outlined" type="check-circle"/>});


                            return UserStore.updateUser(authToken);
                        });
                    }
                });
        }

    }



    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ voteModalIsOpen: false });
    }


    teamOneClicked() {
        this.setState({
            twoBackground: "#041827",
            oneBackground: "#1890ff",
            chosenTeam: 1
        });

    }

    teamTwoClicked() {
        this.setState({
            oneBackground: "#041827",
            twoBackground: "#1890ff",
            chosenTeam: 2
        });
    }

    render() {


        const submitVoteModal = (this.props.propEvent == false ? <Modal
            isOpen={this.state.voteModalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            className="new-bet-modal"
            overlayClassName="new-bet-modal-overlay"
        >
            <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
            <h3 className="single-event-oracle-titles">Who won the game?</h3>
            <div style={{ textAlign: "center", display: "flex", flexDirection: "row", padding: "30px" }}>
                <Card onClick={this.teamOneClicked} bordered={false} style={{ background: this.state.oneBackground, width: 300, padding: "30px" }}>
                    <h2 className="single-event-oracle-subtitles">{this.state.teamOneName}</h2>
                    <img width="150px" height="72px" src={this.state.teamOneLogo} />
                </Card>
                <Card onClick={this.teamTwoClicked} bordered={false} style={{ background: this.state.twoBackground, width: 300, padding: "30px" }}>
                    <h2 className="single-event-oracle-subtitles">{this.state.teamTwoName}</h2>
                    <img width="150px" height="72px" src={this.state.teamTwoLogo} />
                </Card>
            </div>

            <br />
            <br />
            <button onClick={this.closeModal} className="custom-btn-danger">Exit</button>
            <button onClick={this.submitVote} className="custom-btn-success">Submit</button>

        </Modal> :
            <Modal
                isOpen={this.state.voteModalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                className="new-bet-modal"
                overlayClassName="new-bet-modal-overlay"
            >
                <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                <h3 className="single-event-oracle-titles">What happened?</h3>


                <h2>{this.props.propEvent.propTitle}</h2>
                <div style={{ textAlign: "center", display: "flex", flexDirection: "row", padding: "30px" }}>
                    <Card onClick={this.teamOneClicked} bordered={false} style={{ background: this.state.oneBackground, width: 300, padding: "30px" }}>
                        <h2 className="single-event-oracle-subtitles">{this.props.propEvent.teams[0]}</h2>

                    </Card>
                    <Card onClick={this.teamTwoClicked} bordered={false} style={{ background: this.state.twoBackground, width: 300, padding: "30px" }}>
                        <h2 className="single-event-oracle-subtitles">{this.props.propEvent.teams[1]}</h2>

                    </Card>
                </div>
           

                <br />
                <br />
                <button onClick={this.closeModal} className="custom-btn-danger">Exit</button>
                <button onClick={this.submitVote} className="custom-btn-success">Submit</button>

            </Modal>)

        return (
            <div>
                {submitVoteModal}
                {/* <Popconfirm title="Sure you want to cancel this bet?" onConfirm={this.cancelBet} okText="Yes" cancelText="No"> */}
               
                {this.state.chooseButton}
                {/* </Popconfirm> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/appComponents/betting/betStages/SubmitVote.js